import React from 'react';
import TopNavigation from './topNavigation/TopNavigation';

const CreateProject = () => (
  <TopNavigation />
);

export default CreateProject;
